import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// import './deleteWindow.css'

const DeleteConfirmationModal = ({ show, onHide, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("manageProject_deleteWindowTitle")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t("manageProject_deleteWindow")}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("addProject_cancel")}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {t("manageProject_deleteBtn")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
